import React from "react";
import PropTypes from "prop-types";

import IconButton from "components/library/IconButton";
import styles from "./SelectedContent.css";
import StatusIcon from "dashboard/components/StatusIcon";
import {
  getContentImageSrc,
  getContentAuthorDisplay,
  getContentDateString,
} from "utils/contentDisplay";
import Button from "components/library/Button/Button";

export default function SelectedContent({
  content,
  contentPrefix,
  onEdit,
  onRemove,
}) {
  if (!content) return null;

  return (
    <div className={styles.root}>
      <StatusIcon status={content.status} />
      <div className={styles.previewImage}>
        <img
          src={
            getContentImageSrc(content) ||
            "https://static.axios.com/img/axios-site/axios-placeholder-1x1.png"
          }
          height="48"
          width="48"
        />
      </div>
      <div className={styles.storyDetails}>
        <p className={styles.headline}>
          {contentPrefix} {content.headline}
        </p>
        <p className={styles.details}>
          {[
            getContentAuthorDisplay(content),
            content.topics[0] && content.topics[0].name,
            getContentDateString(content, true),
          ]
            .filter(val => val)
            .join(" – ")}
        </p>
      </div>
      {onEdit ? (
        <Button type="tertiary" onClick={onEdit}>
          Edit
        </Button>
      ) : null}
      {onRemove ? (
        <IconButton
          className="gtm-remove-story-from-deep-dive"
          name="x"
          onClick={onRemove}
        />
      ) : null}
    </div>
  );
}

SelectedContent.propTypes = {
  onRemove: PropTypes.func,
  content: PropTypes.object,
  contentPrefix: PropTypes.string,
  onEdit: PropTypes.func,
};
